import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import OverView from "../pages/ticket/TicketList";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path={"/"}
            element={
              <AccessControl
                allowedPermissions={["can_view_ticket"]}
                renderNoAccess={<PermissionRequired />}
              >
                <OverView />
              </AccessControl>
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
